export const menuData = [
    {
        id: 1,
        title: 'Home',
        link: '/',
        showMenu: false
    },
    {
        id: 2,
        title: 'Padron',
        link: '/cigar/padron',
        showMenu: true,
    },
    {
        id: 3,
        title: 'Arturo Fuente',
        link: '/cigar/arturo-fuente',
        showMenu: false,
    },
    {
        id: 4,
        title: 'Oliva',
        link: '/cigar/oliva',
        showMenu: false,
    },
    {
        id: 5,
        title: 'Nub',
        link: '/cigar/nub',
        showMenu: false,
    },
    {
        id: 6,
        title: 'Cain',
        link: '/cigar/cain',
        showMenu: false,
    },
    {
        id: 7,
        title: 'La Garela',
        link: '/cigar/la-garela',
        showMenu: false,
    },
    {
        id: 8,
        title: 'La Flor Dominicana',
        link: '/cigar/la-flor-dominicana',
        showMenu: false,
    },
    {
        id: 9,
        title: 'Ciboa',
        link: '/cigar/ciboa',
        showMenu: false,
    },

    {
        id: 10,
        title: 'Coffe',
        link: '/coffe',
        showMenu: false,
    },
    {
        id: 11,
        title: 'Beer',
        link: '/beer',
        showMenu: false,
    },
    {
        id: 12,
        title: 'Events',
        link: '/events',
        showMenu: false,
    },
    // {
    //     id: 13,
    //     title: 'Contacts',
    //     link: '/contacts',
    //     showMenu: false,
    // }
];

